import React      from 'react';
import CSSModules from 'react-css-modules';
import moment     from 'moment';

import classnames from 'classnames/bind';

import PageLink from '../PageLink';

import stylingUtils from '../../services/stylingUtilities';

import style from './style.scss';

import marketingListItemTypes from "../../services/constants/marketingListItemTypes";

class EventCourseSummary extends React.Component {

    _getEventSummaryClass() {

        var cx = classnames.bind(style);

        var baseStyle = {
            'event': true,
            'event--large': this.props.size === 'large'
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    _getBookingLink() {

        if (this.props.event) {

            if (this.props.event.marketable.elearning_course_id) {
                return `/booking/elearning/${ this.props.event.marketable.id }`;
            }

            return `/booking/${ this.props.event.marketable.id }`;
        }
    }

    _getDetailsLink() {

        if (this.props.event) {
            if(this.props.event.marketable_type === marketingListItemTypes.event.className){
                return `/events/${ this.props.event.marketable.id }/${ this.props.event.marketable.course.slug }`;
            }else{
                return `/courses/${ this.props.event.marketable.id }/${ this.props.event.marketable.slug }`;
            }
        }
    }

    _getEventLink() {
        let fullyBooked = null,
            isMultipleDays = false,
            dayCount = 0,
            fullyBookedMessage = true;

        if(this.props.event.marketable_type === marketingListItemTypes.event.className){
            fullyBooked = this.props.event.marketable.fully_booked;
            isMultipleDays = this.props.event.marketable.multiple_days;
            dayCount = this.props.event.marketable.multiple_days_events ? this.props.event.marketable.multiple_days_events.length : 0;
        }

        return (
            <div styleName="link-container">

                <PageLink
                    onClick={ (e) => e.stopPropagation() }
                    to={ this._getDetailsLink() }
                    styleName="details-link"
                >
                    Details
                </PageLink>

                {!this.props.hideBookNow &&
                <span styleName="divider">|</span>
                }

                {fullyBooked && fullyBookedMessage && (
                    <span>Fully Booked</span>
                )}

                {!this.props.hideBookNow && !fullyBooked && (isMultipleDays && moment().isBefore(this.props.event.marketable.multiple_days_events[0].start_date) || !isMultipleDays) && (
                    <PageLink onClick={ (e) => e.stopPropagation() } to={ this._getBookingLink() } styleName="booking-link">
                        Book Now
                    </PageLink>
                )}

                {isMultipleDays && moment().isAfter(this.props.event.marketable.multiple_days_events[0].start_date) && (
                    <span className={style['event-started']}>Event started</span>
                )}

            </div>
        );
    }

    render() {

        return (
            <div className={ this._getEventSummaryClass() }
                 onClick={ this.props.onClick }
                 style={{ backgroundColor: this.props.event.fully_booked ? '#c7c8ca' : this.props.moduleHexColour }}>

                { this.props.children }

                { this._getEventLink() }

            </div>
        );
    }
}

export default CSSModules(EventCourseSummary, style);


// WEBPACK FOOTER //
// ./components/EventCourseSummary/index.js